<template>
    <div class="togetherDetails">
        <!-- 轮播图 -->
        <div class="swiper">
            <swiper :options="swiperOption">
                <swiper-slide>
                    <img src="http://www.lungchuenjz.cn/Upload/Common/20181024/1b5e6e8e-5ab2-4585-810a-c4c46e7811df.jpg" alt="">
                   
                </swiper-slide>
                <swiper-slide>
                    <img src="http://www.lungchuenjz.cn//Upload/Common/20181024/32792db1-3189-4214-9e12-fbf685133b11.jpg" alt="">
                    
                </swiper-slide>
            <div class="swiper-pagination"  slot="pagination"></div>
            </swiper>
        </div>
        <!-- 除螨服务 -->
        <div class="service">
            <p style="line-height: 24px;">除螨服务（2人团）</p>
            <p style="color: #999999;line-height: 20px;font-size: 12px;padding: 2px 0;">仅限虎门和长安地区1.8米以下床垫使用，同一地址只能享受一次优惠，一次使用，有效期60天。</p>
            <p style="font-weight: 400;font-size: 18px;color: #df006e;">原价￥168元</p>
            <div style="display: flex;align-items:baseline;">
            <p style="font-weight: 400;font-size: 18px;color: #df006e;text-decoration:line-through;padding-right: 16px;">原价￥168元</p>
            <p style="font-weight: 400;font-size: 20px;color: #df006e;">一起购价：116元</p>
            </div>
        </div>
       <!-- 拼单列表 -->
       <div class="orderList" v-if="false">
           <div class="listTop">
               <p>2人在拼单，可直接参与</p>
               <div style="color: #999;" @click="onShowContainer">查看全部 ></div>
           </div>
           <div class="listContent">
               <div class="contentLeft" style="font-size: 12px;"><img src="http://thirdwx.qlogo.cn/mmopen/vi_32/ZicvW1rSQ7k3nWPicTfGAhRsgmFfQgTXwWBYGZ0rHPiaTbms3X1VawTyR7o0Rn4TN2WNrNcwvA6sh9HYyXxUtWNtw/132" alt="">罗世肯</div>
               <div class="contentRight" style="font-size: 12px;line-height: 22px;width: 40%;"><div>还差1人拼成</div><div style="color: rgb(59, 59, 59);">剩余23:00:00</div></div>
               <div class="contentBtn">去拼团</div>
           </div>
           <div class="listContent">
               <div class="contentLeft" style="font-size: 12px;"><img src="http://thirdwx.qlogo.cn/mmopen/vi_32/ZicvW1rSQ7k3nWPicTfGAhRsgmFfQgTXwWBYGZ0rHPiaTbms3X1VawTyR7o0Rn4TN2WNrNcwvA6sh9HYyXxUtWNtw/132" alt="">罗世肯</div>
               <div class="contentRight" style="font-size: 12px;line-height: 22px;width: 40%;"><div>还差1人拼成</div><div style="color: rgb(59, 59, 59);">剩余23:00:00</div></div>
               <div class="contentBtn">去拼团</div>
           </div>
       </div>
       <!-- 本团信息 -->
       <div class="orderMessage">
           <div class="title">本团信息</div>
           <div class="content">
               <div class="contentItem leader" style="padding-right:10px;"><img src="http://thirdwx.qlogo.cn/mmopen/vi_32/ZicvW1rSQ7k3nWPicTfGAhRsgmFfQgTXwWBYGZ0rHPiaTbms3X1VawTyR7o0Rn4TN2WNrNcwvA6sh9HYyXxUtWNtw/132" alt=""></div>
               <div class="contentItem" style="padding-left:10px;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAE1ElEQVRoQ71ai3HUQAzVVgCpAFIBSQVEboBLBRwVcFRAUgFJBSQVEBqwkgoIFZBUwFHBMs8jeXQb+7zrz2kmc5nz7a6e/tI60AwkIq+J6AMRvSWiM/3E/56eiAh/9/r5k5m3U48PYzdQpj8S0ZqITkbu80hEN0R0OxZMMQARgWQ/K+OQfEsxxmdIN4QAKb+gGGOjnRDCm+QhNAEg18wMLWVTEQAR+UpEGyJqGY8x/g4hXME0cg9XIZzFGDchhHeOWwC5YubLXARZAEQEJvI9MZVbIrrIZbqPIQVzQUQwRyOY1nnO3oMARAQ2/s2kHmN8CCGsczbPlSJ+ByAxxpsQwntdB218YWaYVi/tBaDMQ/JG2BDmshiJCEwUAjP6tA9ELwDPfIzxXwjhjJmh2sUJJhtjvA8hvNLDekF0AkiYh5Ou5jaZISkoCJiUOTl84i5d9wKAOqzA5lXyJ4dm3phMNAGfOE156QLwy0UbLCgyGxUAsjJivpFl4OLsq/uBJ9AjM596LewAEBGEM8R6UJHD6kE/tIzYZyEIApclmTdxbKwFnw21ADQeAylM56GqKi/BvSbbEa2a36sJmiP6PaBVLgFR1zWcGiF2x5Q8AEgGJQLoONfuExUb05DQjTGowsH+MC0jZG7eKxn3UPf4o1+1WmgAaGGGhygRUFgheWWRk4wx3xtuExPF/ntjfMqAiCCpIWNDCxDy1gD45FEifRR2JpUshjxgIoJTr7IkpdnandeANwBN5EFhVlVVdmnsnUvt/e2QXSf+smXmo1wA+F1d14+aG5qIFNR8/uompSrdxBhXcK5cxxcRBAfkmYaYebAe8wATARwBAOzd6p1s8ymRWh8DpRpXf/Vmew4ATfRBM1JVVdoGjuWzc51qG+Zq56CBgf8VUV3XaJrQFF0Gc6pcEyg6KfmxiyL2ZJTGPc/QAKIIJLKT4aYw2rW2g/kif0vM0CqGJwCI+nARAGo2KDF8Zi/KNR35oC15FgWgzCPi+NA8WVA+IS4NwJcnWYkux3QPAiCtkUrLhn1AdgD4kOTL1BxJDBzSSn/uCGcAEPoXC6NJzTM64nQJKQ2jJqknZj6eKnlbX9f11jXlqJw7p3VjzvOhf7FSwoVnLXnmAZD0BU0pgR5gVDE3RnpT17wo5rBhWqJOPWTJ9SKyU/pPamgGohCGt02WDyE857aoA3v6SnSnoUEjjwoPDfikNG8MJD4wOftiX6unfPM0uanvk9jcAJLEuNvUKzpMh9GuQQtFE4Oe6tOKRDyerAERQU0Fs8Sctp0WzjbY6qkY7WsIZHQeyBpsuQRkTTO+Kh4tzh2BvOl0taCdw1032sb8BVm0aD46F4icQfPgeB0DVa0kDwqi41orb7zuwqCfVhxUE17yyk/ZBUcPCHy9YebruUykJ3phPuuvscZdMTkQK718sykzogk2LbrPHQKtUsfdWNM7a7jEZeKLWxm/V9ZUTG8Q75I7XQxaEd8nAdHqEncS7UBZ756zrrWyADhtXOjltJ/5w7mh8odcMMo0Zv0YarUNv0odF93tBcaQ5ooAWMbGwTHGtWtY7Bz/QkfX2Z0vghjjeqdQpNFiAE4b6CPWCsS/LjAktPa5e03hbmiq3bfpaAB+Q22KIF2M6Dtf6EheBIHZobyY/LrNf9aOEKZDQPTUAAAAAElFTkSuQmCC" alt=""></div>
           </div>
           <p style="text-align:center;padding-bottom: 10px">仅剩1个名额 剩余16:00:00后结束</p>
       </div>
       <!-- 详情图片 -->
       <div class="detailImg">
           <img src="http://www.lungchuenjz.cn/scupload/image/20181102/6367675828784380713514372.jpg" alt="">
           <img src="http://www.lungchuenjz.cn/scupload/image/20181024/6367599564898716613767029.jpg" alt="">
       </div>
       <!-- 脚步按钮 -->
       <div class="footer">
           <div class="kf" style="background: #009933;width: 30%;color: #fff;"> <span class="iconfont icondianhua" style="padding-right: 6px;"></span>联系客服</div>
           <div class="initiate" style="background: #FFA800;width: 70%;color: #fff;">发起一起购</div>
       </div>
        <!-- 脚步按钮 -->
       <div class="footer" v-show="false">
           <div class="kf" style="background: #fff;width: 30%;"> <span class="iconfont iconhome" style="padding-right: 6px;"></span>首页</div>
           <div class="initiate" style="background: #FFA800;width: 70%; color: #fff;">邀请好友一起购</div>
       </div>
       <!-- 返回按钮 -->
       <div class="back"><span class="iconfont iconzuojiantou" style="color: #fff;"></span></div>
       <!-- 查看全部弹出层 -->
       <van-popup v-model="showContainer" :close-on-click-overlay="false">
           <div class="container">
               <div class="title">正在一起购</div>

               <div class="listOut" style="height: 331px;width: 100%; overflow-y: scroll;position: absolute">
                      <div class="containerList" v-for="(item,index) in 6" :key="index">
                        <div class="contentLeft" style="font-size: 12px;">
                          <img src="http://thirdwx.qlogo.cn/mmopen/vi_32/ZicvW1rSQ7k3nWPicTfGAhRsgmFfQgTXwWBYGZ0rHPiaTbms3X1VawTyR7o0Rn4TN2WNrNcwvA6sh9HYyXxUtWNtw/132" alt="">
                           <div style="font-size: 12px;line-height: 22px;"><div>还差1人拼成</div><div style="color: rgb(59, 59, 59);">剩余23:00:00</div></div>
                        </div>
                        <div class="contentBtn">去拼团</div>
                      </div>
               </div>
               
               <div class="close" @click="close"><van-icon name="close" /></div>
           </div>
       </van-popup>
       <!-- 去拼团弹出层 -->
       <van-popup v-model="showPintuan" :close-on-click-overlay="false">
           <div class="pintuan">
               <div style="text-align: center;height: 20px;">参加罗世肯的一起购</div>
               <div style="text-align: center;color: #7a7a7a;font-size: 14px;line-height: 24px;">仅剩一个名额，剩余23:00:00</div>
                <div class="pinContent">
                    <div class="pinItem leader" style="padding-right:6px;"><img src="http://thirdwx.qlogo.cn/mmopen/vi_32/ZicvW1rSQ7k3nWPicTfGAhRsgmFfQgTXwWBYGZ0rHPiaTbms3X1VawTyR7o0Rn4TN2WNrNcwvA6sh9HYyXxUtWNtw/132" alt=""></div>
                    <div class="pinItem" style="padding-left:6px;"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAE1ElEQVRoQ71ai3HUQAzVVgCpAFIBSQVEboBLBRwVcFRAUgFJBSQVEBqwkgoIFZBUwFHBMs8jeXQb+7zrz2kmc5nz7a6e/tI60AwkIq+J6AMRvSWiM/3E/56eiAh/9/r5k5m3U48PYzdQpj8S0ZqITkbu80hEN0R0OxZMMQARgWQ/K+OQfEsxxmdIN4QAKb+gGGOjnRDCm+QhNAEg18wMLWVTEQAR+UpEGyJqGY8x/g4hXME0cg9XIZzFGDchhHeOWwC5YubLXARZAEQEJvI9MZVbIrrIZbqPIQVzQUQwRyOY1nnO3oMARAQ2/s2kHmN8CCGsczbPlSJ+ByAxxpsQwntdB218YWaYVi/tBaDMQ/JG2BDmshiJCEwUAjP6tA9ELwDPfIzxXwjhjJmh2sUJJhtjvA8hvNLDekF0AkiYh5Ou5jaZISkoCJiUOTl84i5d9wKAOqzA5lXyJ4dm3phMNAGfOE156QLwy0UbLCgyGxUAsjJivpFl4OLsq/uBJ9AjM596LewAEBGEM8R6UJHD6kE/tIzYZyEIApclmTdxbKwFnw21ADQeAylM56GqKi/BvSbbEa2a36sJmiP6PaBVLgFR1zWcGiF2x5Q8AEgGJQLoONfuExUb05DQjTGowsH+MC0jZG7eKxn3UPf4o1+1WmgAaGGGhygRUFgheWWRk4wx3xtuExPF/ntjfMqAiCCpIWNDCxDy1gD45FEifRR2JpUshjxgIoJTr7IkpdnandeANwBN5EFhVlVVdmnsnUvt/e2QXSf+smXmo1wA+F1d14+aG5qIFNR8/uompSrdxBhXcK5cxxcRBAfkmYaYebAe8wATARwBAOzd6p1s8ymRWh8DpRpXf/Vmew4ATfRBM1JVVdoGjuWzc51qG+Zq56CBgf8VUV3XaJrQFF0Gc6pcEyg6KfmxiyL2ZJTGPc/QAKIIJLKT4aYw2rW2g/kif0vM0CqGJwCI+nARAGo2KDF8Zi/KNR35oC15FgWgzCPi+NA8WVA+IS4NwJcnWYkux3QPAiCtkUrLhn1AdgD4kOTL1BxJDBzSSn/uCGcAEPoXC6NJzTM64nQJKQ2jJqknZj6eKnlbX9f11jXlqJw7p3VjzvOhf7FSwoVnLXnmAZD0BU0pgR5gVDE3RnpT17wo5rBhWqJOPWTJ9SKyU/pPamgGohCGt02WDyE857aoA3v6SnSnoUEjjwoPDfikNG8MJD4wOftiX6unfPM0uanvk9jcAJLEuNvUKzpMh9GuQQtFE4Oe6tOKRDyerAERQU0Fs8Sctp0WzjbY6qkY7WsIZHQeyBpsuQRkTTO+Kh4tzh2BvOl0taCdw1032sb8BVm0aD46F4icQfPgeB0DVa0kDwqi41orb7zuwqCfVhxUE17yyk/ZBUcPCHy9YebruUykJ3phPuuvscZdMTkQK718sykzogk2LbrPHQKtUsfdWNM7a7jEZeKLWxm/V9ZUTG8Q75I7XQxaEd8nAdHqEncS7UBZ756zrrWyADhtXOjltJ/5w7mh8odcMMo0Zv0YarUNv0odF93tBcaQ5ooAWMbGwTHGtWtY7Bz/QkfX2Z0vghjjeqdQpNFiAE4b6CPWCsS/LjAktPa5e03hbmiq3bfpaAB+Q22KIF2M6Dtf6EheBIHZobyY/LrNf9aOEKZDQPTUAAAAAElFTkSuQmCC" alt=""></div>
                </div>
                <div class="pinBtn">参加拼团</div>
                <div class="close"><van-icon name="close" /></div>
           </div>
       </van-popup>
    </div>
</template>

<script>
export default {
    data(){
        return{
            swiperOption:{
                pagination: {
                el: '.swiper-pagination'
                },
                loop: true,
                autoplay: 5000
          },
            showContainer:false,
            showPintuan:false
        }
    },
    mounted() {
    
    
         
  },
    methods:{
        onShowContainer(){
            this.showContainer = true
        },
        onShowPintuan(){
            this.showPintuan = true
        },
        close(){
            this.showContainer = false
            this.showPintuan = false
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.togetherDetails
  width 100%
  background: rgb(240, 240, 240)
  & >>>.van-popup
      overflow-y: visible;
  .swiper
    width 100%
    & img
      width 100%
  .service
    padding 8px
    background white
    margin-bottom 14px
  .detailImg
    width 100%
    margin-bottom 54px
    &>img
      width 100%
  .footer
    width: 100%
    height 54px
    background: white
    position: fixed
    left: 0
    right: 0
    bottom: 0
    display: flex
    align-items: center
    &>div
      display: flex
      align-items: center
      justify-content center
      height 100%
  .back
    height: 30px;
    width: 30px;
    border-radius: 50%;
    background rgba(0,0,0,0.3)
    position: fixed
    top: 10px;
    left: 10px;
    z-index 100
    display: flex
    align-items: center
    justify-content center
  .orderList
    width 100%
    background #fff
    margin-bottom 8px
    .listTop
      box-sizing border-box
      width 100%
      padding 6px
      display flex
      justify-content space-between
      font-size 14px
      border-bottom: 1px solid #f0f0f0;
    .listContent
      box-sizing border-box
      width 100%  
      padding 12px 8px
      display flex
      justify-content space-between
      align-items center
      border-bottom: 1px solid #f0f0f0;
      .contentLeft
        display flex
        align-items center
        &>img
          width: 44px;
          height: 44px;
          border-radius: 50%;
          padding-right 8px
      .contentBtn
        color: #fff;
        padding: 8px 12px;
        border-radius: 4px;
        background-color: rgb(247, 37, 34);
        font-size: 12px;
  .container
    width calc(100vw - 80px)
    height 380px
    position relative
    .close
      position absolute
      width 36px
      height 36px
      background #aaa6a6
      border-radius: 50%;
      top -14px
      right -14px
      display: flex
      align-items: center
      justify-content center
      font-size 28px
    .title
      height 48px
      display: flex
      align-items: center
      justify-content center
      border-bottom: 1px solid #f0f0f0;
    .containerList
      display: flex
      align-items: center
      justify-content space-between
      padding 12px 8px
      box-sizing border-box
      border-bottom: 1px solid #f0f0f0;
      .contentLeft
        display: flex
        align-items: center
        &>img
          width: 44px;
          height: 44px;
          border-radius: 50%;
          padding-right 8px
      .contentBtn
        color: #fff;
        padding: 8px 12px;
        border-radius: 4px;
        background-color: rgb(247, 37, 34);
        font-size: 12px;
        margin-right: 18px;
  .pintuan
    width calc(100vw - 80px)
    position relative
    padding 14px
    .close
      position absolute
      width 36px
      height 36px
      background #aaa6a6
      border-radius: 50%;
      top -14px
      right -14px
      display: flex
      align-items: center
      justify-content center
      font-size 28px
    .pinContent
      width 100%
      display flex
      height 64px
      align-items: center
      justify-content center
      margin-bottom 8px
      .pinItem
        position relative
      & img
        width: 44px;
        height: 44px;
        border-radius: 50%;
        padding-right 8px
      .leader::after
        position: absolute;
        top: -6px;
        left: 14px;
        width: 36px;
        height: 16px;
        display: inline-block;
        background: #F49A30;
        border-radius: 8px;
        content: '团长';
        font-size: 10px;
        text-align: center;
        color: #fbf6f6;
        border: 1px solid #fff;
    .pinBtn
      width: 90%;
      height 38px
      line-height 38px
      margin 0 auto
      padding: 6px 0;
      text-align: center;
      color: #fff;
      font-size: 16px;
      border-radius: 6px;
      background: #ce1a1a;
  .orderMessage
    width 100%
    background #fff
    margin-bottom 8px
    .title
      padding 6px
      border-bottom: 1px solid #f0f0f0;
    .content
      padding 14px 14px 10px
      display flex
      .contentItem
        position relative
      & img
        width: 44px;
        height: 44px;
        border-radius: 50%;
        padding-right 8px
      .leader::after
        position: absolute;
        top: -6px;
        left: 14px;
        width: 36px;
        height: 16px;
        display: inline-block;
        background: #F49A30;
        border-radius: 8px;
        content: '团长';
        font-size: 10px;
        text-align: center;
        color: #fbf6f6;
        border: 1px solid #fff;

</style>



// WEBPACK FOOTER //
// src/pages/Together/TogetherDetails.vue